// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const orderApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    getAllOrders: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `order?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getOrderDetails: builder.query({
      query: (id) => {
        // let queryString = new URLSearchParams(query).toString();
        return {
          url: `order?${id}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllOrdersQuery, useGetOrderDetailsQuery } = orderApi;
